module.exports = __webpack_public_path__ + "static/media/messenger.d4654aff.svg";